module.exports = __webpack_public_path__ + "img/africa-icon.2d53a689.svg";